import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ResultEditor = ({ raceId, onClose, onSaved }) => {
  const [race, setRace] = useState(null);
  const [fin, setFin] = useState({});

  useEffect(() => {
    api.get(`/races/${raceId}`).then(({ data }) => {
      setRace(data);
      const placings = data.result?.placings || [];
      setFin(Object.fromEntries(data.horses.map((h) => [h.name, placings.find((p) => p.number === h.number || p.name?.toUpperCase() === h.name?.toUpperCase())?.finish ?? ""])));
    }).catch((e) => toast.error(formatApiError(e)));
  }, [raceId]);

  const save = async () => {
    const placings = race.horses.filter((h) => fin[h.name] !== "").map((h) => ({ number: h.number, name: h.name, finish: Number(fin[h.name]) }));
    try {
      await api.put(`/races/${raceId}/result`, { placings });
      toast.success("Result saved");
      onSaved();
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#0F172A] border-slate-800 max-w-md" data-testid="result-editor">
        <DialogHeader><DialogTitle>{race ? `${race.venue} R${race.race_number} — finishing positions` : "Loading..."}</DialogTitle></DialogHeader>
        {race && (
          <div className="max-h-[60vh] overflow-y-auto space-y-1.5 pr-1">
            {race.horses.filter((h) => !h.scratched).map((h, i) => (
              <label key={h.name} className="flex items-center justify-between gap-3 text-sm">
                <span><span className="num text-emerald-400 mr-2">{h.number}</span>{h.name}</span>
                <input type="number" min="1" data-testid={`result-finish-${i}`} value={fin[h.name] ?? ""} onChange={(e) => setFin({ ...fin, [h.name]: e.target.value })}
                  className="w-16 h-8 bg-[#080C14] border border-slate-700 rounded px-2 num text-center focus:outline-none focus:border-emerald-500" />
              </label>
            ))}
          </div>
        )}
        <Button onClick={save} disabled={!race} data-testid="result-save-button" className="w-full mt-2">Save result</Button>
      </DialogContent>
    </Dialog>
  );
};
